import * as React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import DashModal from "./DashModel";
// import AddNewTask from "./AddNewTask";
import ReminderAdd from "./ReminderAdd";
import TaskAdd from "./TaskAdd";

export default function BasicList({
  tasks,
  setTasks,
  getReminders,
  reminders,
}) {
  const [open, setOpen] = React.useState({
    status: false,
    modal: "",
  });

  // for open specific modal either task or reminder
  const handleClick = (modal, status) => {
    setOpen({
      ...open,
      status: status,
      modal: modal,
    });
  };

  const handleClose = (modal, status) => {
    setOpen({
      ...open,
      status: status,
      modal: modal,
    });
  };
  console.log(open);
  return (
    <>
      <Box
        sx={{
          width: "200px",
          maxWidth: 200,
          textAlign: "center",
          bgcolor: "background.paper",
        }}
      >
        <nav aria-label="main mailbox folders">
          <List disablePadding>
            <ListItem
              disablePadding
              onClick={() => handleClick("reminder", true)}
            >
              <ListItemButton>
                <ListItemText
                  primary="Add Reminder"
                  style={{ textAlign: "center" }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
        {/* <Divider />
        <nav aria-label="secondary mailbox folders">
          <List disablePadding>
            <ListItem disablePadding onClick={() => handleClick("task", true)}>
              <ListItemButton>
                <ListItemText
                  primary="Add Task"
                  style={{ textAlign: "center" }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </nav> */}
      </Box>
      {open.status && (
        <DashModal
          title={open.modal === "task" ? "Task" : "Reminder"}
          open={open}
          handleClick={handleClick}
          content={
            open.modal === "task" ? (
              <TaskAdd
                tasks={tasks}
                getReminders={getReminders}
                handleClose={() => handleClose("", false)}
              />
            ) : (
              <ReminderAdd
                getReminders={getReminders}
                reminders={reminders}
                handleClose={() => handleClose("", false)}
              />
            )
          }
        />
      )}
    </>
  );
}
